import Cookies from "js-cookie";
import axios from "axios";
import base_url from "../constants";

const axiosInstance = axios.create({
    baseURL: base_url,
});

axiosInstance.interceptors.request.use(
    (config) => {
        const token = Cookies.get("token");
        console.log("token from axiosInstance: ", token);

        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default axiosInstance;
